import api from "./api";
import { AxiosResponse } from "axios";
import { GovernmentalEntityVersion } from "reducers/types/governmentalEntity";

const BASE_URL = "/ms-admin-rest/api/v1.0";

export type GetVersionsResponseType = {
  result: GovernmentalEntityVersion[];
};

export const getVersions = (
  limit = 10
): Promise<AxiosResponse<GetVersionsResponseType>> =>
  api.get(`${BASE_URL}/regulatory-file-uploads`, {
    params: { limit },
  });

export const uploadVersion = (file: File): Promise<AxiosResponse<void>> => {
  const formData = new FormData();
  formData.append("file", file);

  return api.post(`${BASE_URL}/regulatory-file-uploads`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
